var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps noselect"},[_vm._l((_vm.computedSteps),function(step){return _c('div',{key:step.key,class:step.classes},[_vm._v(_vm._s(step.title))])}),_c('div',{staticClass:"line"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }